const setupSlideToggle = (container) => {
  const children = Array.from(container.children);
  const trigger = children.find((child) => child.tagName === "BUTTON");

  if (!trigger || trigger.dataset.slideToggleInit) {
    return;
  }

  trigger.dataset.slideToggleInit = "true";

  const panels = children.filter((child) => child !== trigger);
  const target = trigger.nextElementSibling;
  const openIcon = trigger.querySelector(".open");
  const closeIcon = trigger.querySelector(".close");

  const syncIcons = (isHidden) => {
    if (openIcon) {
      openIcon.classList.toggle("hidden", !isHidden);
    }

    if (closeIcon) {
      closeIcon.classList.toggle("hidden", isHidden);
    }
  };

  panels.forEach((panel) => {
    panel.classList.add("slide-toggle-panel", "hide");
    panel.setAttribute("aria-hidden", "true");
  });

  trigger.setAttribute("aria-expanded", "false");

  if (!target || !panels.includes(target)) {
    return;
  }

  target.style.display = "grid";
  syncIcons(true);

  trigger.addEventListener("click", () => {
    const isClosed = target.classList.contains("hide");

    if (isClosed) {
      target.classList.remove("hide");
      target.setAttribute("aria-hidden", "false");
      trigger.setAttribute("aria-expanded", "true");
      syncIcons(false);
      return;
    }

    target.classList.add("hide");
    target.setAttribute("aria-hidden", "true");
    trigger.setAttribute("aria-expanded", "false");
    syncIcons(true);
  });
};

export const initSlideToggles = (root = document) => {
  root.querySelectorAll(".slide-toggle").forEach(setupSlideToggle);
};

initSlideToggles();
